import React from "react";
import loadable from '@loadable/component'
import LoadingIndicator from "../../CommonUI/LoadingIndicator";

export default loadable(() => import('./index'), {
    fallback: <LoadingIndicator overlay={false}/>
});
